(() => {
  const modalSelector = 'modal-dialog.collection-quick-add-modal';

  const syncVariant = (modal, select) => {
    const option = select?.selectedOptions?.[0];
    if (!option) return;

    const price = modal.querySelector('[data-collection-quick-add-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    const image = modal.querySelector('[data-collection-quick-add-image]');
    if (image && option.dataset.image) image.src = option.dataset.image;

    const quantity = modal.querySelector('[data-collection-quick-add-quantity]');
    if (quantity) {
      const min = Number(option.dataset.min || 1);
      const step = Number(option.dataset.step || 1);
      quantity.min = String(min);
      quantity.step = String(step);
      quantity.value = String(Math.max(min, Number(quantity.value || min)));

      if (option.dataset.max) {
        quantity.max = option.dataset.max;
        if (Number(quantity.value) > Number(option.dataset.max)) quantity.value = option.dataset.max;
      } else {
        quantity.removeAttribute('max');
      }
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-collection-variant-select]');
    if (!select) return;
    const modal = select.closest(modalSelector);
    if (modal) syncVariant(modal, select);
  });

  document.addEventListener('click', (event) => {
    const cancel = event.target.closest?.('[data-collection-quick-add-close]');
    if (!cancel) return;
    const modal = cancel.closest(modalSelector);
    modal?.hide();
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(modalSelector).forEach((modal) => {
      syncVariant(modal, modal.querySelector('[data-collection-variant-select]'));
    });
  }, { once: true });
})();
